import { AxiosInstance } from 'axios';
import { LOCAL_STORAGE_KEY } from '../../../helpers/jwt';
import { sendSentryData } from '../../../configs/sendSentryData';

export type Middleware = (instance: AxiosInstance) => void;

export enum responseStatus {
    BAD_REQUEST_ERROR = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    UNPROCESSABLE_ENTITY = 422,
    SERVER_ERROR = 500,
}

const BYPASSABLE_STATUSES: number[] = [responseStatus.BAD_REQUEST_ERROR, responseStatus.UNPROCESSABLE_ENTITY];

declare module 'axios' {
    export interface AxiosRequestConfig {
        bypassGlobalErrorHandler?: boolean;
    }
}

enum messageTypes {
    SUCCESS,
    VALIDATION_ERROR,
    SERVER_ERROR,
    LOG,
    INFO,
}

export const setMiddleware: Middleware = (instance) => {
    instance.interceptors.response.use(
        (response) => {
            const { SUCCESS, VALIDATION_ERROR, SERVER_ERROR } = messageTypes;
            if (response.data.messages && response.data.messages.length > 0) {
                for (let messageObj of response.data.messages) {
                    const { type, message } = messageObj;
                    switch (type) {
                        case SUCCESS:
                            break;
                        case VALIDATION_ERROR:
                            console.error({ type: 'error', message });
                            break;
                        case SERVER_ERROR:
                            console.error({ type: 'error', message });
                            break;
                    }
                }
            }
            return response;
        },
        (error) => {
            const {
                BAD_REQUEST_ERROR,
                FORBIDDEN,
                NOT_FOUND,
                UNPROCESSABLE_ENTITY,
                SERVER_ERROR,
                UNAUTHORIZED,
            } = responseStatus;
            if (error.response) {
                const { status } = error.response;
                switch (status) {
                    case FORBIDDEN:
                        console.error({
                            type: 'error',
                            message: 'Forbidden : Вам не разрешено производить данное действие.',
                        });
                        break;
                    case NOT_FOUND:
                        console.error('Page not found');
                        break;
                    case UNAUTHORIZED:
                        sendSentryData({
                            data: error.response,
                            message: 'Failed request API',
                        });
                        localStorage.removeItem(LOCAL_STORAGE_KEY);
                        window.location.reload();
                        break;
                    case SERVER_ERROR:
                    case BAD_REQUEST_ERROR:
                    case UNPROCESSABLE_ENTITY: {
                        if (error.config?.bypassGlobalErrorHandler && BYPASSABLE_STATUSES.includes(status)) {
                            break;
                        }
                        sendSentryData({
                            data: error.response,
                            message: 'Failed request API',
                        });
                        break;
                    }
                }
            }
            return Promise.reject(error);
        },
    );

    return instance;
};
